import React from 'react'

interface Step {
  title: string
  description: string
  status: 'upcoming' | 'current' | 'completed'
}

interface StepIndicatorProps {
  steps: Step[]
  currentStep: number
}

const StepIndicator = ({ steps, currentStep }: StepIndicatorProps) => {
  return (
    <div className="relative">
      {/* 背景线 */}
      <div className="absolute top-4 left-0 right-0 h-0.5 bg-gray-200" />

      {/* 步骤列表 */}
      <div className="relative grid grid-cols-4 gap-4">
        {steps.map((step, index) => (
          <div key={index} className="flex flex-col items-center">
            {/* 圆圈 - 使用更小的尺寸 */}
            <div className={`
              w-8 h-8 rounded-full flex items-center justify-center mb-2
              text-sm font-bold relative z-10
              ${step.status === 'completed' 
                ? 'bg-primary text-white' 
                : step.status === 'current'
                  ? 'bg-accent text-white'
                  : 'bg-gray-200 text-gray-500'}
            `}>
              {index + 1}
            </div>

            {/* 文字说明 - 更紧凑的布局 */}
            <div className="text-center">
              <div className={`text-sm font-medium mb-0.5 ${
                step.status === 'completed' || step.status === 'current'
                  ? 'text-gray-800'
                  : 'text-gray-500'
              }`}>
                {step.title}
              </div>
              <div className="text-xs text-gray-500">
                {step.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default StepIndicator 